import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS_PUBLIC from '../events/REQUIRED_FIELDS_PUBLIC';

export default function useActiveInvitationsForUser(user, options = {}) {
  return useConnect('event.find', {
    where: {
      eager: {
        $where: {
          invitations: {
            $where: {
              userId: user.id,
              response: 'Yes'
            }
          },
          $and: REQUIRED_FIELDS_PUBLIC.$and
        }
      }
    },
    pagination: {
      page: options.page || 1,
      pageSize: options.pageSize || 3,
      order: 'createdAt desc'
    }
  });
}
